import * as THREE from 'three';
import { mm } from './units';

export const KEY_W = mm(23.5);
export const KEY_H = mm(10);
export const KEY_D = mm(150);

export const CUT_W = KEY_W / 3;
export const CUT_D = KEY_D / 2;

export const FLASH_SEC   = 0.15;
export const FLASH_COLOR_WHITE = new THREE.Color(0xffd700);
export const FLASH_COLOR_BLACK = new THREE.Color(0xff4400);

export const SEMI_NOTCHES: readonly [0 | 1, 0 | 1][] = [
  [0, 1], [0, 0], [1, 1], [0, 0], [1, 0],
  [0, 1], [0, 0], [1, 1], [0, 0], [1, 1],
  [0, 0], [1, 0],
];

export const isWhite       = (n: number) => ![1, 3, 6, 8, 10].includes(n % 12);
export const hasBlackAfter = (s: number)   => [0, 2, 5, 7, 9].includes(s);
